import { render, staticRenderFns } from "./Centers.vue?vue&type=template&id=d61c4e76&"
import script from "./Centers.vue?vue&type=script&lang=js&"
export * from "./Centers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports